
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefae9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefae9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ge6e3", function(module, exports) {

$parcel$export(module.exports, "stringifyNum", () => $bd02c871d9c5ba8e$export$32c352b6867c6f6d);
$parcel$export(module.exports, "makeAbsolute", () => $bd02c871d9c5ba8e$export$79fc5653e15ea47f);
$parcel$export(module.exports, "reduceData", () => $bd02c871d9c5ba8e$export$93738ca0a9c2679b);
$parcel$export(module.exports, "crunchData", () => $bd02c871d9c5ba8e$export$17d14716b77fbbac);
$parcel$export(module.exports, "filterNonStrings", () => $bd02c871d9c5ba8e$export$313cb2a0ae7013dc);
$parcel$export(module.exports, "kFormatter", () => $bd02c871d9c5ba8e$export$467981646dda0d75);
$parcel$export(module.exports, "createShortDate", () => $bd02c871d9c5ba8e$export$d0673deee714e759);
$parcel$export(module.exports, "createLongDate", () => $bd02c871d9c5ba8e$export$ff455ac72342f5f6);
const $bd02c871d9c5ba8e$export$32c352b6867c6f6d = (number)=>number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
const $bd02c871d9c5ba8e$export$79fc5653e15ea47f = (num)=>Math.abs(num);
const $bd02c871d9c5ba8e$export$93738ca0a9c2679b = (arr)=>arr.reduce((acc, num)=>acc + num, 0);
const $bd02c871d9c5ba8e$export$17d14716b77fbbac = function(arr) {
    if (!Array.isArray(arr) || arr.length < 1) return [];
    const singleNumber = $bd02c871d9c5ba8e$export$93738ca0a9c2679b(arr);
    return (singleNumber / arr.length).toFixed(2);
};
const $bd02c871d9c5ba8e$export$313cb2a0ae7013dc = (arr)=>{
    let filtered = arr.filter((item)=>typeof item === "string" || typeof item === "number").map((item)=>+item);
    if (filtered.length < 1) filtered = [
        0
    ];
    return filtered;
};
const $bd02c871d9c5ba8e$export$467981646dda0d75 = function(num, decimal = 999, unit = "k") {
    if (!num) return 0;
    return Math.abs(num) > decimal ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(2) + unit : Math.sign(num) * Math.abs(num);
};
const $bd02c871d9c5ba8e$export$d0673deee714e759 = function(specifiedDate = "") {
    let joinedDate;
    if (specifiedDate) {
        const [month, date, year] = new Date(specifiedDate).toLocaleDateString("en-US").split("/");
        joinedDate = date + "/" + month + "/" + year.slice(-2);
    } else {
        const [month, date, year] = new Date().toLocaleDateString("en-US").split("/");
        joinedDate = date + "/" + month + "/" + year.slice(-2);
    }
    return joinedDate;
};
const $bd02c871d9c5ba8e$export$ff455ac72342f5f6 = function(shortDate) {
    let [year, month, day] = shortDate.split("/").reverse();
    // check if each data has the correct length
    if (year.length !== 2 || month.length > 2 && month.length < 1 || day.length > 2 || day.length < 1) return "ERROR";
    // coerce the string into numbers
    year = +("20" + year);
    month = +month;
    day = +day;
    // check if day, month or year failed the coercion due to incorrect format
    if (!year || !month || !day) return "ERROR";
    // get current year
    const currentYear = new Date().getFullYear();
    // run year, day and month range validation
    if ((year < 2010) ?? year > currentYear) return "ERROR";
    if (month < 0 || month > 12) return "ERROR";
    if (day < 1 || day > 31) return "ERROR";
    const fullDate = new Date(year, month - 1, day);
    return String(fullDate);
};

});

parcelRegister("fZ5A9", function(module, exports) {

$parcel$export(module.exports, "ENTRIES_PER_PAGE", () => $ba30e20475feac5a$export$d44a016ef85794c7);
$parcel$export(module.exports, "MONTHS_FORMAT", () => $ba30e20475feac5a$export$d87ac258782f4034);
$parcel$export(module.exports, "USER_USERNAME", () => $ba30e20475feac5a$export$4cd43f3a67e51a2b);
$parcel$export(module.exports, "USER_PASSWORD", () => $ba30e20475feac5a$export$5b906a9a1fc9de4);
const $ba30e20475feac5a$export$d44a016ef85794c7 = 8;
const $ba30e20475feac5a$export$d87ac258782f4034 = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec"
];
const $ba30e20475feac5a$export$4cd43f3a67e51a2b = "trader";
const $ba30e20475feac5a$export$5b906a9a1fc9de4 = "app";

});

parcelRequire("ge6e3");

var $fZ5A9 = parcelRequire("fZ5A9");
let $d0b2c38c793eadc2$var$formEls = {};
const $d0b2c38c793eadc2$var$getElements = function(obj = {}) {
    obj.enterBtn = document.querySelector(".js-enter-btn");
    obj.joinBtn = document.querySelector(".js-join-btn");
    obj.usernameInput = document.querySelector(".js-login-username");
    obj.passwordInput = document.querySelector(".js-login-password");
    obj.loginMessage = document.querySelector(".js-form-message");
    return obj;
};
const $d0b2c38c793eadc2$var$clearLoginInputs = function() {
    $d0b2c38c793eadc2$var$formEls.usernameInput.value = "";
    $d0b2c38c793eadc2$var$formEls.passwordInput.value = "";
};
const $d0b2c38c793eadc2$var$compareLoginDetails = function(inputUsername, inputPassword) {
    if (inputUsername !== (0, $fZ5A9.USER_USERNAME) || inputPassword !== (0, $fZ5A9.USER_PASSWORD)) {
        $d0b2c38c793eadc2$var$formEls.loginMessage.textContent = "Incorrect username and/or password";
        setTimeout(()=>{
            $d0b2c38c793eadc2$var$formEls.loginMessage.textContent = "";
        }, 5000);
        return;
    }
    $d0b2c38c793eadc2$var$clearLoginInputs();
    window.location.href = "../../app.html";
};
const $d0b2c38c793eadc2$export$e77163acc0373c7f = function() {
    $d0b2c38c793eadc2$var$formEls = $d0b2c38c793eadc2$var$getElements({});
    $d0b2c38c793eadc2$var$formEls.enterBtn.addEventListener("click", (e)=>{
        e.preventDefault();
        const inputtedUsername = $d0b2c38c793eadc2$var$formEls.usernameInput.value;
        const inputtedPassword = $d0b2c38c793eadc2$var$formEls.passwordInput.value;
        $d0b2c38c793eadc2$var$compareLoginDetails(inputtedUsername, inputtedPassword);
    });
    $d0b2c38c793eadc2$var$formEls.joinBtn.addEventListener("click", (e)=>{
        e.preventDefault();
        $d0b2c38c793eadc2$var$formEls.loginMessage.textContent = "Join option is currently unavailable";
        setTimeout(()=>{
            $d0b2c38c793eadc2$var$formEls.loginMessage.textContent = "";
        }, 5000);
    });
};


window.addEventListener("DOMContentLoaded", (e)=>{
    (0, $d0b2c38c793eadc2$export$e77163acc0373c7f)();
});


//# sourceMappingURL=index.4a351143.js.map
